export const PublishedInformationRows = [
    {
        title: '期刊类型',
        key: 'journal_type'
    },
    {
        title: '研究类型',
        key: 'article_type'
    },
    {
        title: '是否有病例',
        key: 'case_concluded'
    },
    {
        title: 'PMID',
        key: 'pmid'
    },
]
export const BasicDiseasesRows = [
    { title: '合并基础疾病', key: 'comorbidities' },
    { title: '恶性肿瘤', key: 'malignant_tumor' },
    { title: '脑血管疾病', key: 'cerebrovascular_disease' },
    { title: '神经系统疾病', key: 'neurological_disease' },
    { title: '呼吸系统疾病', key: 'respiratory_disease' },
    { title: '内分泌系统疾病', key: 'endocrine_disease' },
    { title: '消化系统疾病', key: 'digestive_diseases' },
]

export const SymptomsRows = [
    { title: '发热', key: 'fever' },
    { title: '咳嗽', key: 'cough' },
    { title: '呼吸困难', key: 'dyspnea' },
    { title: '肌肉酸痛', key: 'muscle_soreness' },
    { title: '腹泻', key: 'diarrhea' },
    { title: '头痛', key: 'headache' },
    { title: '鼻塞', key: 'stuffy_nose' },
    { title: '咽痛', key: 'sore_throat' },
    { title: '恶心呕吐', key: 'nausea_vomiting' },
    { title: '胸疼', key: 'chest_pain' },
]

export const ResultRows = [
    { title: '治愈出院', key: 'heald_discharge' },
    { title: '死亡', key: 'death' },
    { title: '留院观察', key: 'observation' },
]

export const ComplicationsRows = [
    { title: '急性呼吸窘迫综合征（ARDS）', key: 'ards' },
    { title: '急性肾损伤', key: 'aute_kidney_injury' },
    { title: '急性呼吸道损伤', key: 'acute_respiratory_injury' },
    { title: '败血性休克', key: 'sepsis_shock' },
    { title: '呼吸机相关性肺炎', key: 'ventilator_associated_pneumonia' },
]

export const SignsRows = [
    { title: '扁桃体肿大', key: 'tonsil_enlarge'},
    { title: '喉咙充血', key: 'throat_congestion' },
    { title: '淋巴结肿大', key: 'throat_congestion' },
    { title: '皮疹', key: 'rash' },   
]

export const BaselineCharacteristicsRows = [
    { title: '样本量', key: 'sample_size'},
    { title: '武汉居住或旅游史', key: 'wuhan_travel_history' },
    { title: '武汉华南海鲜市场接触史', key: 'wuhan_huananmarket_history' }, 
    { title: '吸烟史', key: 'smoking_history' },
    { title: '妊娠', key: 'pregnancy' }, 
]
export const DiseasePeriod = [
    { title: '潜伏期', key: 'incubation_days' }, 
    { title: '诊断至肺炎发生时间', key: 'diagnosis_to_pneumonia_days' },
    { title: '症状发作至肺炎发现时间', key: 'symptom-onset_to_pneumonia_days' }, 
]
/**
 * @description 核酸检测
 */
export const NucleicAcidTestRows = [
    { title: '核酸检测阳性', key: 'nucleic_acid_positive' }, 
    { title: '核酸检测阳性耗费检测次数', key: 'times_to_nucleic_acid_positive' },
]
/**
 * @description 重症数量
 */
export const SevereCaseRows = [
    { title: '重症', key: 'severe_case' }, 
    { title: '非重症', key: 'nonsevere_case' },
]
/**
 * @description 治疗方案
 */
export const TreatmentInformationRows = [
    { title: '支持治疗', key:'supportive_care'},
    { title: '联合疗法', key:'combination_therapy'},
    { title: '抗生素', key:'antibiotics'},
    { title: '奥司他韦', key:'oseltamivir'},
    { title: '抗真菌药', key:'antifungal'},
    { title: '抗病毒药', key:'antiviral'},
    { title: '全身性糖皮质激素', key:'glucocorticoid'},
    { title: '糖皮质激素单日最大剂量', key:'glucocorticoid_maxium_dailydose'},
    { title: '吸氧', key:'oxygen'},
    { title: '机械通气', key:'mechanical_ventilation'},
    { title: '有创机械通气', key:'invasive_mechanical_ventilation'},
    { title: '体外膜氧合', key:'ecmo'},
    { title: '静脉免疫球蛋白', key:'ivig'},
    { title: '连续性肾脏替代治疗', key:'continuous_renal_replacement'},
    { title: '入住ICU', key:'icu_admission'},
    { title: '无创呼吸机机械通气', key:'noninvasive_mechanical_ventilation'},
]